module.exports = __webpack_public_path__ + "static/img_02-8837a631806576fdc638257672d09c34.png";